import { render, staticRenderFns } from "./ValvalueNew.vue?vue&type=template&id=39b00994"
import script from "./ValvalueNew.vue?vue&type=script&lang=js"
export * from "./ValvalueNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports